import React, {FC, useState, useEffect} from "react"

import theme from "@irati/ui/src/global/theme"
import Flex from "@irati/ui/src/Flex"
import {H2, Body} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import {OnboardingReportStep} from "@irati/types"
import {hangPromise} from "@irati/utils/promise"
import Loading from "@irati/ui/src/Loading"
import {IconTypes} from "@irati/ui/src/Icon"

import {IconButton} from "@irati/ui/src/Button"
import onboarding from "../../../images/onboarding.svg"
import complete from "../../../images/onboarding_complete.svg"
import {ONBOARDING_STEPS, Step, Action} from "./Steps"
import OnboardingStep from "./Step"
import {CustomCard, StepsIndicator, ActiveBar, FinalStep, StepContainer} from "./styled"

const ACTION_STEPS = 14

interface Props {
  reportingSteps?: OnboardingReportStep[]
  expanded?: boolean
}

const Onboarding: FC<Props> = ({reportingSteps, expanded = false}) => {
  const [steps, setSteps] = useState<Step[]>()
  const [active, setActive] = useState<number>(0)
  const [isExpanded, setIsExpanded] = useState(expanded)
  const [load, setLoad] = useState<Promise<any> | null>(hangPromise())

  const mapOnboardingSteps = () => {
    const updatedSteps = ONBOARDING_STEPS
    let activeSteps = 0
    updatedSteps.map((step) => {
      step.actions.map((item) => {
        const completedAction = reportingSteps?.find((s) => s.step === item.name)?.complete
        item.complete = completedAction || false
        if (completedAction) {
          activeSteps += 1
        }
      })
    })
    setActive(activeSteps)
    setSteps(updatedSteps)
    setLoad(null)
  }

  useEffect(() => {
    mapOnboardingSteps()
  }, [reportingSteps])

  return (
    <CustomCard noBorder marginBottom={expanded ? 5 : 2} paddingTop={isExpanded ? 4 : 2} paddingBottom={isExpanded ? 4 : 2}>
      <Flex justifyContent="space-between" alignItems="center">
        <Flex justifyContent="space-between" marginBottom={isExpanded ? 3 : 0} width="90%">
          <img src={onboarding} height={100} width={150} alt="adminSection_onboardingSVG" />
          <Flex direction="column" alignSelf="center" marginLeft={4} width="100%">
            <H2 marginBottom color={theme.colors.filterChip}>
              <FormattedMessage id="admin.components.onboarding.title" />
            </H2>
            {isExpanded && (
              <Body small marginBottom={2}>
                <FormattedMessage id="admin.components.onboarding.subTitle" />
              </Body>
            )}
            <StepsIndicator>
              <ActiveBar steps={ACTION_STEPS} active={active} />
              <FinalStep src={complete} alt="adminSection_onboarding_complete" />
            </StepsIndicator>
          </Flex>
        </Flex>
        <IconButton size={20} onClick={() => setIsExpanded(!isExpanded)} icon={isExpanded ? IconTypes.chevronUp : IconTypes.chevronDown} />
      </Flex>
      <Loading load={load}>
        {isExpanded && (
          <Flex width="100%" wrap="wrap" gap={theme.spacing.one} id="adminSection_onboardingSteps">
            {steps?.map((step, index) => {
              const title = step.title
              return (
                <StepContainer key={index} flex="1" direction="column" justifyContent="space-between" padding={[2, 1, 0, 2]}>
                  <Flex direction="column">
                    <Body large color={theme.colors.filterChip} marginBottom={2}>
                      <FormattedMessage id={title} />
                    </Body>
                    <Flex direction="column" marginBottom marginTop>
                      {step.actions?.map((item: Action, i: number) => {
                        return <OnboardingStep event={step.event} action={item} index={i} />
                      })}
                    </Flex>
                  </Flex>
                </StepContainer>
              )
            })}
          </Flex>
        )}
      </Loading>
    </CustomCard>
  )
}

export default Onboarding
